import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import logo from "@/assets/logo.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-white">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center gap-2 mb-10" data-testid="brand-link">
          <img src={logo} alt="Pranav Anand Enterprises" className="h-14 w-auto object-contain"/>
          <span className="font-heading font-semibold text-base" style={{color:"#0e5a32"}}>Pranav Anand Enterprises</span>
        </Link>
        {sent ? (
          <div data-testid="forgot-sent">
            <MailCheck className="w-10 h-10 text-[#0e5a32] mb-4" strokeWidth={1.4}/>
            <h1 className="text-3xl font-heading font-semibold tracking-tight mb-2">Check your email</h1>
            <p className="text-sm text-gray-500 mb-8">If an account exists for <span className="font-medium text-gray-700">{email}</span>, we've sent a link to reset your password. The link expires in 60 minutes.</p>
            <Link to="/login"><Button variant="outline" className="rounded-sm w-full" data-testid="forgot-back-login">Back to sign in</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-heading font-semibold tracking-tight mb-2" data-testid="forgot-title">Forgot password?</h1>
            <p className="text-sm text-gray-500 mb-8">Enter your account email and we'll send you a link to reset your password.</p>
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-xs font-medium uppercase tracking-wider text-gray-600">Email</Label>
                <Input id="email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm mt-1"/>
              </div>
              <Button type="submit" disabled={submitting} data-testid="forgot-submit" className="w-full bg-[#002fa7] hover:bg-[#00227b] rounded-sm">
                {submitting ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <p className="text-sm text-gray-500 mt-6">
              Remembered it? <Link to="/login" className="text-[#002fa7] font-medium hover:underline" data-testid="forgot-to-login">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
